import { useCallback } from "react";
import { useSelector } from "react-redux";
import { getQueryData } from "src/helpers/helpers";
import useFetchAsync from "src/hooks/useFetchAsync";
import { deleteReq, useGet, usePatch, usePost } from "src/http-clients/clients";
import { getActiveStoreId } from "src/redux/selectors/app";

export const useCreateStaff = () => {
  const activeStore = useSelector(getActiveStoreId);
  return usePost(`/users/${activeStore}/staff/create-member`);
};

export const useGetStaff = ({
  length,
  page,
  search,
}: {
  length: number;
  page: number;
  search?: string;
}) => {
  const activeStore = useSelector(getActiveStoreId);
  const offset = page === 1 ? 0 : (page - 1) * length;
  const queryData = getQueryData({ length, offset, search });
  const data = useGet(`/users/${activeStore}/staff/list${queryData}`);
  return data;
};

export const useGetStaffData = (staffId: number) => {
  const activeStore = useSelector(getActiveStoreId);
  return useGet(
    staffId ? `/users/${activeStore}/staff/member/${staffId}` : null
  );
};

export const useUpdateStaff = (staffId: number) => {
  const activeStore = useSelector(getActiveStoreId);
  return usePatch(`/users/${activeStore}/staff/member/${staffId}`);
};

export const useDeleteStaff = () => {
  const activeStore = useSelector(getActiveStoreId);
  const deleteData = useCallback(
    (staffId: number) => {
      return deleteReq(`/users/${activeStore}/staff/member/${staffId}`);
    },
    [activeStore]
  );
  return useFetchAsync(deleteData);
};

export const useDeleteStaffIdentityDoc = () => {
  const activeStore = useSelector(getActiveStoreId);
  const deleteData = useCallback(
    (staffId: number) => {
      return deleteReq(
        `/users/${activeStore}/staff/member/${staffId}/identity-doc`
      );
    },
    [activeStore]
  );
  return useFetchAsync(deleteData);
};

export const useDeleteStaffImage = () => {
  const activeStore = useSelector(getActiveStoreId);
  const deleteData = useCallback(
    (staffId: number) => {
      return deleteReq(
        `/users/${activeStore}/staff/member/${staffId}/user-image`
      );
    },
    [activeStore]
  );
  return useFetchAsync(deleteData);
};
